import { render, staticRenderFns } from "./transformation.vue?vue&type=template&id=c4eae1fa"
import script from "./transformation.vue?vue&type=script&lang=js"
export * from "./transformation.vue?vue&type=script&lang=js"
import style0 from "./transformation.vue?vue&type=style&index=0&id=c4eae1fa&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports